import ApiService from '../api-service'

export type TDriverLocation = {
  lat: number
  lon: number
  heading: number
}

export const driverLocation = (rideId: number) => ApiService.get<undefined, Promise<{ driver: TDriverLocation }>>(`/rides/${rideId}/location`, {})

export interface IWaypoint {
  index: number;
  type: string;
  lat: number;
  lon: number;
  pickup_at: string;
  ride_id: number;
  at: string;
}
export interface IDriverWaypoints {
  polyline: 'string' | null;
  waypoints: IWaypoint[];
}
export const driverWaypoints = (driverId: number) => ApiService.get<{ driver_id: number }, Promise<IDriverWaypoints>>('/rides/driver-waypoints', {
  data: {
    driver_id: driverId
  }
})
